import React, { useState, useRef } from 'react';
import GeneralIcon from '../../../../../assets';

export default function AdicionarDocumento({ document, onClose, onSave }) {
  const [title, setTitle] = useState(document?.title || '');
  const [description, setDescription] = useState(document?.description || '');
  const [category, setCategory] = useState(document?.tipo || '');
  const [textContent, setTextContent] = useState(document?.textContent || '');
  const [attachments, setAttachments] = useState(document?.attachments || []);
  
  const fileInputRef = useRef(null);

  const categories = ['Nota fiscal', 'Anotação', 'Termo', 'Quatro', 'Contrato de fornecimento', 'Contrato de produto', 'Relatório', 'Outro'];

  function handleFileSelect(e) {
    const files = Array.from(e.target.files);
    const newAttachments = files.map(file => ({
      id: Date.now() + Math.random(),
      name: file.name,
      file: file,
      type: getFileType(file.name)
    }));
    setAttachments(prev => [...prev, ...newAttachments]);
  }

  function getFileType(filename) {
    const ext = filename.split('.').pop().toLowerCase();
    if (ext === 'pdf') return 'PDF';
    if (['doc', 'docx'].includes(ext)) return 'DOC';
    if (ext === 'txt') return 'TXT';
    if (['jpg', 'jpeg', 'png', 'gif'].includes(ext)) return 'IMG';
    return ext.toUpperCase();
  }

  function getFileTypeColor(type) {
    const colors = {
      PDF: 'bg-red-100 text-red-700',
      DOC: 'bg-blue-100 text-blue-700',
      TXT: 'bg-gray-100 text-gray-700',
      IMG: 'bg-purple-100 text-purple-700'
    };
    return colors[type] || 'bg-gray-100 text-gray-700';
  }

  function removeAttachment(id) {
    setAttachments(prev => prev.filter(a => a.id !== id));
  }

  function handleSave() {
    const doc = {
      id: document?.id || Date.now(),
      title,
      description,
      tipo: category,
      textContent,
      attachments
    };
    onSave(doc);
  }

  return (
    <div className="fixed inset-0 bg-black/40 z-50 overflow-auto">
      <div className="min-h-screen flex items-start justify-center p-6">
        <div className="bg-white rounded-lg w-full max-w-md p-6 max-h-[90vh] overflow-y-auto">
          <div className="flex items-center gap-3 mb-6">
            <button onClick={onClose} className="p-2 rounded hover:bg-gray-100">
              ←
            </button>
            <h3 className="text-lg font-semibold">
              {document ? 'Editar documento' : 'Adicionar documento'}
            </h3>
          </div>

          <div className="space-y-4">
            {/* Title */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Título do desconto<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="Contrato de fornecimento"
                className="w-full border rounded px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
              />
            </div>

            {/* Description */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Descrição<span className="text-red-500">*</span>
              </label>
              <textarea
                value={description}
                onChange={e => setDescription(e.target.value)}
                placeholder="Pode ser permitir a primavera"
                rows={3}
                className="w-full border rounded px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none resize-none"
              />
            </div>

            {/* Category */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Categoria do documento<span className="text-red-500">*</span>
              </label>
              <select
                value={category}
                onChange={e => setCategory(e.target.value)}
                className="w-full bg-gray-50 border rounded px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none"
              >
                <option value="">Selecione...</option>
                {categories.map(cat => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>

            {/* Text Content */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Conteúdo em texto
              </label>
              <textarea
                value={textContent}
                onChange={e => setTextContent(e.target.value)}
                placeholder="Remover estoques"
                rows={3}
                className="w-full border rounded px-3 py-2 focus:ring-2 focus:ring-purple-500 focus:outline-none resize-none"
              />
            </div>

            {/* Attachments */}
            <div>
              <label className="block text-sm font-medium mb-2">Anexos</label>
              
              {attachments.length > 0 && (
                <div className="space-y-2 mb-3">
                  {attachments.map(att => (
                    <div
                      key={att.id}
                      className="flex items-center justify-between p-2 border rounded"
                    >
                      <div className="flex items-center gap-2 flex-1 min-w-0">
                        <span className={`px-2 py-1 rounded text-xs font-medium ${getFileTypeColor(att.type)}`}>
                          {att.type}
                        </span>
                        <span className="text-sm truncate">{att.name}</span>
                      </div>
                      <button
                        onClick={() => removeAttachment(att.id)}
                        className="text-red-500 hover:text-red-700 ml-2"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}

              <button
                onClick={() => fileInputRef.current?.click()}
                className="w-full border-2 border-dashed border-purple-400 rounded-lg py-4 text-purple-600 hover:bg-purple-50 transition flex flex-col items-center gap-2"
              >
                <GeneralIcon iconName="upload" className="w-6 h-6" />
                <span className="text-sm">Adicionar IMG, DOC, PDF ou TXT</span>
              </button>
              
              <input
                ref={fileInputRef}
                type="file"
                multiple
                accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif"
                onChange={handleFileSelect}
                className="hidden"
              />
            </div>

            {/* Action Buttons */}
            <button
              onClick={handleSave}
              className="w-full py-3 rounded bg-purple-600 text-white font-medium hover:bg-purple-700 transition mt-6"
            >
              {document ? 'Atualizar' : 'Adicionar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
